<template>
  <v-container fluid>
    <div>
      <PostCheckingSettings v-bind:sleuth-config.sync="sleuthConfig" v-on="$listeners" />
      <BotSettings v-bind:sleuth-config.sync="sleuthConfig" v-on="$listeners" />
      <ModSettings  v-bind:sleuth-config.sync="sleuthConfig" v-on="$listeners" />
      <SearchFilterSettings v-bind:sleuth-config.sync="sleuthConfig" v-on="$listeners" />
    </div>
    <div>
      <v-btn block color="primary" @click="saveOnClick" :loading="saving">Save</v-btn>
    </div>
  </v-container>

</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import PostCheckingSettings from "@/components/manage-subreddits/PostCheckingSettings";
import BotSettings from "@/components/manage-subreddits/BotSettings";
import ModSettings from "@/components/manage-subreddits/ModSettings";
import SearchFilterSettings from "@/components/manage-subreddits/SearchFilterSettings";

const MonitoredSubRepo = RepositoryFactory.get('monitored')
export default {
  name: "SubredditSettings",
  components: {SearchFilterSettings, ModSettings, BotSettings, PostCheckingSettings},
  data: () => ({
    sleuthConfig: null,
    saving: false
  }),
  props: {
    subredditName: String
  },
  methods: {
    getSleuthConfig() {
      return MonitoredSubRepo.getMonitoredSubConfig({params: {token: this.$store.getters.token}}, this.subredditName)
          .then(res => {
            this.sleuthConfig = res.data
          })
    },
    saveOnClick() {
      this.saving = true;
      MonitoredSubRepo.updateMonitoredSub(this.sleuthConfig, {params: {token: this.$store.getters.token}})
          .then(res => {
            this.saving = false;
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
            } else {
              this.$emit('on-alert', {color: 'success', message: 'Settings Saved'})
            }
          })
    }
  },
  mounted() {
    this.getSleuthConfig();
  }
}
</script>

<style scoped>

</style>
